import { Phone, MapPin, ArrowUpRight, ArrowRight } from "lucide-react";
import FadeIn from "@/components/FadeIn";
import { scrollToId } from "@/lib/scroll";

export default function ClimFooter() {
  return (
    <footer data-testid="clim-footer" className="relative bg-ink pb-24 text-white md:pb-0">
      <div className="mx-auto max-w-7xl px-5 pt-24 sm:px-8 sm:pt-32">
        <FadeIn>
          <div className="relative overflow-hidden rounded-3xl bg-ice p-10 sm:p-16">
            <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/20 blur-[80px]" />
            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-white/80 sm:text-xs">
              Cet été, respirez
            </p>
            <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-5xl">
              Votre devis climatisation Daikin, gratuit et sans engagement.
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-white/85">
              Monosplit posé dès 2 500 €, installation sous 15 jours, zéro
              sous-traitance. Un technicien vous rappelle sous 24 h ouvrées.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <button
                data-testid="clim-footer-cta"
                onClick={() => scrollToId("#devis")}
                className="group flex items-center gap-2 rounded-full bg-white px-7 py-4 text-base font-bold text-ice transition-all hover:scale-[1.03]"
              >
                Obtenir mon devis
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </button>
              <a
                href="tel:+33535759803"
                data-testid="clim-footer-phone-cta"
                className="flex items-center gap-2.5 rounded-full border border-white/40 px-7 py-4 text-base font-semibold text-white transition-all hover:bg-white/10"
              >
                <Phone className="h-4 w-4" /> Appeler le 05 35 75 98 03
              </a>
            </div>
          </div>
        </FadeIn>

        <div className="grid gap-12 py-16 sm:grid-cols-3">
          <div>
            <img
              src="/logo-enersolutions.png"
              alt="Ener Solutions"
              className="h-10 w-auto rounded-md bg-white px-2 py-1.5"
            />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/55">
              Installateur RGE de climatisation Daikin, pompes à chaleur et
              panneaux solaires en Nouvelle-Aquitaine.
            </p>
          </div>
          <div>
            <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-sky-300">
              Contact
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-white/65">
              <li className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sky-300/70" />
                3 rue de la Dauge, 33240 Saint-André-de-Cubzac
              </li>
              <li>
                <a
                  href="tel:+33535759803"
                  data-testid="clim-footer-phone"
                  className="flex items-center gap-2.5 transition-colors hover:text-sky-300"
                >
                  <Phone className="h-4 w-4 text-sky-300/70" /> 05 35 75 98 03
                </a>
              </li>
              <li>
                <a
                  href="https://www.ener-solutions.pro"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="clim-footer-website"
                  className="flex items-center gap-1.5 transition-colors hover:text-sky-300"
                >
                  www.ener-solutions.pro <ArrowUpRight className="h-3.5 w-3.5" />
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-sky-300">
              Zones d'intervention
            </h3>
            <p className="mt-5 text-sm leading-relaxed text-white/65">
              Gironde · Charente · Charente-Maritime · Dordogne · Lot-et-Garonne · Landes
            </p>
            <a
              href="/"
              data-testid="clim-footer-link-pac"
              className="mt-5 inline-flex items-center gap-1.5 rounded-full border border-emerald-400/40 px-3.5 py-1.5 text-xs font-semibold text-emerald-300 transition-colors hover:bg-emerald-400/10"
            >
              Pompe à chaleur & aides 2026 <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-white/10 py-8 text-[11px] leading-relaxed text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Ener Solutions — Installateur RGE QualiPAC & QualiPV.</p>
          <p className="max-w-xl sm:text-right">
            Prix indicatif « dès 2 500 € » pour un monosplit posé, selon configuration. Daikin est une marque de Daikin Industries, Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
}
